var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTochka(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3996 11.9996C14.3996 13.3256 13.3256 14.3996 11.9996 14.3996C10.6736 14.3996 9.59961 13.3256 9.59961 11.9996C9.59961 10.6736 10.6736 9.59961 11.9996 9.59961C13.3256 9.59961 14.3996 10.6736 14.3996 11.9996Z",
    fill: "#71869D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTochka);
export default __webpack_public_path__ + "static/media/iconTochka.0833d7bf9fb814641367faf6d9737c27.svg";
export { ForwardRef as ReactComponent };